import * as React from "react";
import Link, { LinkProps } from "@components/link";
import { cn } from "@/helpers/classNames";

export type TextLinkProps = LinkProps;

const TextLink: React.FC<TextLinkProps> = ({
  to,
  className,
  children = undefined,
  ...props
}) => (
  <Link
    to={to}
    className={cn("focus-visible:rounded hover-underline", className)}
    {...props}
  >
    {children}
  </Link>
);

export default TextLink;
